const regexpRules = {
  //20230322 取引先一括登録指摘対応： /^\d{13}$/g => /^\d{13}$/
  /** @description 発行元法人番号 */
  ISSUE_CORPORATE_NUMBER: /^\d{13}$/,
  /** @description メールアドレス */
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/,
  /** @description メールアドレスのドメイン */
  EMAIL_DOMAIN: /^@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/,
  /** @description 自社商品コード */
  OWN_PRODUCT_CODE: /[^A-Za-z0-9!-/:-@\[-~]/g,
}

export default regexpRules
